export const ITALY_MAX_GAME_LIMIT_AMOUNT_IN_CENTS = 100000;